/* Orelle — añadir "extras" desde el carrito lateral sin salir de él */
(function () {
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-gc-extra-form]');
    if (!form) return;
    var drawer = form.closest('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function' || !window.fetch) return; // en /cart: envío normal
    e.preventDefault();
    var btn = form.querySelector('button');
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    var fd = new FormData(form);
    fd.delete('return_to');
    if (typeof drawer.getSectionsToRender === 'function') {
      fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
    }
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: fd
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) { form.submit(); return; }
      drawer.classList.remove('is-empty');
      drawer.renderContents(res);
    }).catch(function () { form.submit(); });
  });
})();
